import { useLottie } from "lottie-react";
import animationData from "./empty-cart.json";

const LottieComponent = () => {
  const defaultOptions = {
    animationData: animationData,
    loop: true,
  };

  const { View } = useLottie(defaultOptions);

  return (
    <>
      <div className="">
        <div className="w-60 h-60 mx-auto">{View}</div>
      </div>
    </>
  );
};

export default LottieComponent;

